export default [
    '$scope',
    'SPClientRoute',
    function KeyboardHelpController($scope, SPClientRoute) {
        if (typeof $scope.keyboardContextKey !== 'string') {
            $scope.keyboardContextKey = SPClientRoute.getControllerName();
        }
    }
];
